import _ from 'lodash';
import moment from 'moment';
import store from 'stores/';
import { IntlProvider } from 'react-intl';
import AppLocale from '../lngProvider/';

import {loadState, saveState} from '../stores/localStorage';


const email = ( val ) => { 
  const state = store.getState();
  const currentAppLocale = AppLocale[state.settings.locale.locale];
  const { intl } = new IntlProvider({ locale: currentAppLocale.locale , messages: currentAppLocale.messages  }, {}).getChildContext();
  const msg = intl.formatMessage( {id: 'fieldError.email'});
  return val && /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test( val ) ? null : msg;
}

const equalTo = ( fieldFromValue, fieldToValue, fieldToLabel ) => {
  const state = store.getState();
  const currentAppLocale = AppLocale[state.settings.locale.locale];
  const { intl } = new IntlProvider({ locale: currentAppLocale.locale , messages: currentAppLocale.messages  }, {}).getChildContext();
  const msg = intl.formatMessage( {id: 'fieldError.equalTo'}, { label:fieldToLabel } );
  return fieldFromValue === fieldToValue ? null : msg;
}

const minLength = ( val, length ) => {
  const state = store.getState();
  const currentAppLocale = AppLocale[state.settings.locale.locale];
  const { intl } = new IntlProvider({ locale: currentAppLocale.locale , messages: currentAppLocale.messages  }, {}).getChildContext();
  const msg = intl.formatMessage( {id: 'fieldError.minLength'},{length : length});
  return val && val.length >= length ? null : msg;
}

const greaterOrEqual = ( val, min ) => {
  const state = store.getState();
  const currentAppLocale = AppLocale[state.settings.locale.locale];
  const { intl } = new IntlProvider({ locale: currentAppLocale.locale , messages: currentAppLocale.messages  }, {}).getChildContext();
  const msg = intl.formatMessage( {id: 'fieldError.greaterOrEqual'},{min : min});
  return val ? val >= min ? null : msg : null;
}

const dateGreaterThanNowYear = ( fieldToValue, years ) => {
  const state = store.getState();
  const currentAppLocale = AppLocale[state.settings.locale.locale];
  const { intl } = new IntlProvider({ locale: currentAppLocale.locale , messages: currentAppLocale.messages  }, {}).getChildContext();
  const msg = intl.formatMessage( {id: 'fieldError.dateGreaterThanNowYear'},{years : years});
  return moment().diff(fieldToValue, 'years', false) >= years ? null : msg;
}

const greaterThan = ( val, min, fieldToLabel ) => {
  const state = store.getState();
  const currentAppLocale = AppLocale[state.settings.locale.locale];
  const { intl } = new IntlProvider({ locale: currentAppLocale.locale , messages: currentAppLocale.messages  }, {}).getChildContext();
  const msg = intl.formatMessage( {id: 'fieldError.greaterThan'},{fieldToLabel:fieldToLabel});
  return val ? val > min ? null : msg : null;
}

const required = ( val ) => {
  const state = store.getState();
  const currentAppLocale = AppLocale[state.settings.locale.locale];
  const { intl } = new IntlProvider({ locale: currentAppLocale.locale , messages: currentAppLocale.messages  }, {}).getChildContext();
  const msg = intl.formatMessage( {id: 'fieldError.required'});
  return _.isBoolean( val ) ? val ? null : msg + state.settings.locale.locale : val && val.toString().length ? null : msg ;
}

const passwordValidation = ( val ) => {
  const state = store.getState();
  const currentAppLocale = AppLocale[state.settings.locale.locale];
  const { intl } = new IntlProvider({ locale: currentAppLocale.locale , messages: currentAppLocale.messages  }, {}).getChildContext();
  const msg = intl.formatMessage( {id: 'fieldError.password'});
  return val.match( /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z]{6,}$/ ) ? null
  : msg;
}

const validUrl = ( val ) => {
  const state = store.getState();
  const currentAppLocale = AppLocale[state.settings.locale.locale];
  const { intl } = new IntlProvider({ locale: currentAppLocale.locale , messages: currentAppLocale.messages  }, {}).getChildContext();
  const msg = intl.formatMessage( {id: 'fieldError.url'});
  return val ? val.match( /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/ ) ? null
  : msg : null;
}

const validZip = ( val ) => {
  const state = store.getState();
  const currentAppLocale = AppLocale[state.settings.locale.locale];
  const { intl } = new IntlProvider({ locale: currentAppLocale.locale , messages: currentAppLocale.messages  }, {}).getChildContext();
  const msg = intl.formatMessage( {id: 'fieldError.zip'});
  return val && /^\d{4,5}(?:-\d{4})?$/.test( val ) ? null : msg;
}

const validPhone = ( val ) => {
  const state = store.getState();
  const currentAppLocale = AppLocale[state.settings.locale.locale];
  const { intl } = new IntlProvider({ locale: currentAppLocale.locale , messages: currentAppLocale.messages  }, {}).getChildContext();
  const msg = intl.formatMessage( {id: 'fieldError.phone'});
  
  let strRegExp = /^[+]?254[0-9]{9}$/;
  if (state.settings.externalCustomer === 'apu') {
    strRegExp = /^[+]?52[\u0020]?[0-9]{10}$/;
  }
  if (state.settings.externalCustomer === 'kplc') {
    strRegExp = /^[+]?254[\u0020]?[0-9]{9}$/;
  }
  return val && strRegExp.test( val ) ? null : msg;
}
const validPhone2 = ( val ) => {
  const state = store.getState();
  const currentAppLocale = AppLocale[state.settings.locale.locale];
  const { intl } = new IntlProvider({ locale: currentAppLocale.locale , messages: currentAppLocale.messages  }, {}).getChildContext();
  const msg = intl.formatMessage( {id: 'fieldError.phone'});
  let strRegExp = /^[+]?07[0-9]{8}$/;
  if (state.settings.externalCustomer === 'apu') {
    strRegExp = /^[+]?52[\u0020]?[0-9]{10}$/;
  }
  if (state.settings.externalCustomer === 'kplc') {
    strRegExp = /^[+]?254[\u0020]?[0-9]{9}$/;
  }
  return val && strRegExp.test( val ) ? null : msg;
}
const validPhoneLEC = ( val ) => {
  const state = store.getState();
  const currentAppLocale = AppLocale[state.settings.locale.locale];
  const { intl } = new IntlProvider({ locale: currentAppLocale.locale , messages: currentAppLocale.messages  }, {}).getChildContext();
  const msg = intl.formatMessage( {id: 'fieldError.phone'});
  return val && /^[0]?[0-9]{9}$/.test( val ) ? null : msg;
}
const validFixedLine = ( val ) => {
  const state = store.getState();
  const currentAppLocale = AppLocale[state.settings.locale.locale];
  const { intl } = new IntlProvider({ locale: currentAppLocale.locale , messages: currentAppLocale.messages  }, {}).getChildContext();
  const msg = intl.formatMessage( {id: 'fieldError.fixedLine'});
  let strRegExp = /^([+]?020(20|41|40|42|43|44|45|46|50|51|52|53|54|55|56|57|58|59|60|61|62|64|65|66|67|68|69)[0-9]{5}|[+]?07[0-9]{8})$/;
  if (state.settings.externalCustomer === 'apu') {
    strRegExp = /^[+]?52[\u0020]?[0-9]{10}$/;
  }
  if (state.settings.externalCustomer === 'kplc') {
    strRegExp = /^[+]?254[\u0020]?[0-9]{9}$/;
  }
  return val && strRegExp.test( val ) ? null : msg;
}

const contactValidations = ( contact ) => {
  return {
    full_name: required( contact.full_name ),
    title: required( contact.title ),
    address: required( contact.address ),
    city: required( contact.city ),
    state: required( contact.state ),
    zip: required( contact.zip ) ? required( contact.zip ) : validZip( contact.zip ),
    phone: required( contact.phone ),
    email: required( contact.email ) ? required( contact.email ) : email( contact.email ),
  }
};

const companyValidations = ( company ) => {
  return {
    company: required( company.company ),
    brand: {
      name: required( _.get( company, 'brand.name' ) ),
      industry: required( _.get( company, 'brand.industry' ) ),
      website: validUrl( _.get( company, 'brand.website' ) ),
    },
  }
};

module.exports = {
  email,
  equalTo,
  minLength,
  required,
  passwordValidation,
  validUrl,
  validZip,
  validPhone,
  validPhone2,
  validFixedLine,
  greaterOrEqual,
  contactValidations,
  companyValidations,
  validPhoneLEC,
  greaterThan,
  dateGreaterThanNowYear
};



// WEBPACK FOOTER //
// ./constants/InputErrors.js